import { reactive } from 'vue'

export default reactive({

    two: {
        image: null,
        useil: true,
        canvas: null,
        cropData: null,
        checked: false,
        name: '',

    },

    three: {
        player: 'hierlaender',
        text: 'Viel Spaß mit dem Freundebuch\n' +
            'Deine Mama und Papa',
    },


    five: {
        design: '1'
    },

});
